<template>
  <div class="withdraw-page">
    <van-nav-bar
      :title="$t('withdraw.with_center')"
      left-arrow
      class="withdraw-nav"
      @click-left="back"
    />

    <div class="withdraw-body">
      <section class="block">
        <div class="block-label">{{ $t('withdraw.withdrawal_method') }}</div>
        <van-radio-group v-model="withdrawMethod" direction="horizontal" class="method-group">
          <van-radio name="virtual" icon-size="18px">{{ $t('withdraw.virtual_address') }}</van-radio>
        </van-radio-group>
      </section>

      <!-- 未绑定：虚线添加框 -->
      <section v-if="!hasBoundForMethod" class="block">
        <div class="bind-box" @click="goBind">
          <van-icon name="plus" class="bind-plus" />
          <span>{{ $t('withdraw.wallet_network') }}</span>
        </div>
      </section>

      <!-- 虚拟地址：网络列表 -->
      <section v-else-if="withdrawMethod === 'virtual'" class="block">
        <div class="block-label">{{ $t('withdraw.wallet_network') }}</div>
        <van-radio-group v-model="selectedAddressId">
          <div
            v-for="item in cryptoList"
            :key="item.id"
            class="network-row"
          >
            <van-radio :name="item.id" icon-size="18px">
              <span class="network-name">{{ item.bankfenhang }}</span>
              <span class="network-addr">({{ item.bankid }})</span>
            </van-radio>
          </div>
        </van-radio-group>
      </section>

      <!-- 银行卡 -->
      <section v-else class="block">
        <div class="block-label">{{ $t('withdraw.wallet_network') }}</div>
        <div v-if="bankInfo" class="bank-summary">
          <div class="bank-line"><span>{{ $t('setting.username') }}</span> {{ bankDisplayName }}</div>
          <div class="bank-line"><span>{{ $t('setting.band_name') }}</span> {{ bankInfo.bankinfo }}</div>
          <div class="bank-line"><span>{{ $t('setting.band_account') }}</span> {{ bankDisplayAccount }}</div>
        </div>
      </section>

      <section class="block amount-block">
        <div class="block-label">{{ $t('withdraw.with_money') }}</div>
        <div class="amount-row">
          <span class="amount-prefix">$</span>
          <input
            v-model="withdraw_money"
            type="number"
            class="amount-input"
            :placeholder="maxPlaceholder"
          />
          <span class="amount-all" @click="allMoney">{{ $t('index.all') }}</span>
        </div>
        <div class="remain-row">
          <span>{{ $t('withdraw.remaining_amount') }}: </span>
          <span class="remain-value">{{ remainAmount }}</span>
        </div>
      </section>

      <van-button class="submit-btn" block @click="onWithdrawClick">
        {{ $t('withdraw.withdraw_now') }}
      </van-button>
    </div>

    <van-dialog
      v-model="showPwdDialog"
      :title="$t('withdraw.enter_pay_password')"
      show-cancel-button
      :before-close="onPwdDialogClose"
    >
      <input
        :value="pay_password"
        type="tel"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="6"
        class="pwd-native-input"
        :placeholder="$t('auth.pay_pwd_place')"
        autocomplete="one-time-code"
        @input="onPayPwdInput"
      />
    </van-dialog>
  </div>
</template>

<script>
const BANK_NETWORK = 'BANK';

export default {
  data() {
    return {
      withdrawMethod: 'virtual',
      withdraw_money: '',
      pay_password: '',
      showPwdDialog: false,
      userInfo: {},
      withdrawRole: { min: 0, max: 0, num: 0 },
      cryptoList: [],
      bankInfo: null,
      selectedAddressId: null,
    };
  },
  computed: {
    remainAmount() {
      const m = Number(this.userInfo.money);
      return Number.isFinite(m) ? m.toFixed(2) : '0.00';
    },
    maxPlaceholder() {
      const max = Number(this.withdrawRole.max);
      const v = Number.isFinite(max) ? max.toFixed(2) : '0.00';
      return `${this.$t('withdraw.maximum')}${v}`;
    },
    hasBoundForMethod() {
      if (this.withdrawMethod === 'virtual') {
        return this.cryptoList.length > 0;
      }
      return !!this.bankInfo;
    },
    bankParsed() {
      if (!this.bankInfo || !this.bankInfo.bankid) return {};
      try {
        return JSON.parse(this.bankInfo.bankid);
      } catch (e) {
        return { account: this.bankInfo.bankid };
      }
    },
    bankDisplayAccount() {
      return this.bankParsed.account || '';
    },
    bankDisplayName() {
      return this.bankParsed.cardholder || this.bankInfo.username || '';
    },
  },
  watch: {
    withdrawMethod() {
      this.syncDefaultSelection();
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    goBind() {
      const tab = this.withdrawMethod === 'bank' ? 'bank' : 'virtual';
      this.$router.push({ path: '/BindCard', query: { tab } });
    },
    allMoney() {
      this.withdraw_money = this.userInfo.money;
    },
    loadBankList() {
      return this.$http({ method: 'get', url: 'user_get_bank' }).then((res) => {
        if (res.code !== 200 || !res.data) return;
        const list = res.data.crypto_list || [];
        this.cryptoList = list.filter((x) => x.bankfenhang && x.bankfenhang !== BANK_NETWORK);
        this.bankInfo = list.find((x) => x.bankfenhang === BANK_NETWORK) || null;
        this.syncDefaultSelection();
      });
    },
    syncDefaultSelection() {
      if (this.withdrawMethod === 'virtual' && this.cryptoList.length) {
        const cur = this.cryptoList.find((x) => x.id === this.selectedAddressId);
        if (!cur) {
          this.selectedAddressId = this.cryptoList[0].id;
        }
      }
    },
    getUserInfo() {
      return this.$http({ method: 'get', url: 'user_info' }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (!res.data.paypassword) {
            this.$toast(this.$t('withdraw.please_set_pay_password_first'));
            this.$router.push({ path: '/SetPayPassword', query: { redirect: '/Withdraw' } });
          }
        }
      });
    },
    getUserWithdrawRole() {
      return this.$http({ method: 'get', url: 'user_get_withdraw_role' }).then((res) => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        }
      });
    },
    onPayPwdInput(e) {
      const v = (e.target.value || '').replace(/\D/g, '').slice(0, 6);
      this.pay_password = v;
      e.target.value = v;
    },
    onWithdrawClick() {
      if (!this.hasBoundForMethod) {
        this.$toast(
          this.withdrawMethod === 'bank'
            ? this.$t('withdraw.please_bind_bank_first')
            : this.$t('withdraw.please_bind_address_first')
        );
        this.goBind();
        return;
      }
      if (this.withdrawMethod === 'virtual' && !this.selectedAddressId) {
        this.$toast(this.$t('withdraw.please_select_address'));
        return;
      }
      const amount = Number(this.withdraw_money);
      if (!amount || amount <= 0) {
        this.$toast(this.$t('setting.correct_money'));
        return;
      }
      this.pay_password = '';
      this.showPwdDialog = true;
    },
    onPwdDialogClose(action, done) {
      if (action === 'cancel') {
        done();
        return;
      }
      if (!this.pay_password || this.pay_password.length !== 6) {
        this.$toast(this.$t('auth.pay_pwd_error'));
        done(false);
        return;
      }
      this.doWithdraw().finally(() => done());
    },
    doWithdraw() {
      const addressId =
        this.withdrawMethod === 'virtual'
          ? this.selectedAddressId
          : this.bankInfo && this.bankInfo.id;
      if (!addressId) {
        this.$toast(this.$t('withdraw.please_bind_address_first'));
        return Promise.resolve();
      }
      return this.$http({
        method: 'post',
        url: 'user_set_withdraw',
        data: {
          money: this.withdraw_money,
          paypassword: this.pay_password,
          address_id: addressId,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.withdraw_money = '';
          this.getUserInfo();
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    if (this.$route.query.method === 'bank') {
      this.withdrawMethod = 'bank';
    }
    Promise.all([this.getUserInfo(), this.getUserWithdrawRole(), this.loadBankList()]);
  },
  activated() {
    if (localStorage.getItem('token')) {
      if (this.$route.query.method === 'bank') {
        this.withdrawMethod = 'bank';
      }
      this.loadBankList();
    }
  },
};
</script>

<style scoped>
.withdraw-page {
  min-height: 100vh;
  background: #fff;
}

.withdraw-nav {
  background: #fff;
}

.withdraw-nav::v-deep .van-nav-bar__title {
  color: #111;
  font-weight: 500;
}

.withdraw-nav::v-deep .van-nav-bar__arrow {
  color: #969799;
}

.withdraw-body {
  padding: 16px 20px 32px;
}

.block {
  margin-bottom: 22px;
}

.block-label {
  font-size: 15px;
  font-weight: 600;
  color: #7d3c68;
  margin-bottom: 14px;
}

.method-group {
  display: flex;
  gap: 28px;
}

.method-group::v-deep .van-radio__label {
  color: #333;
  font-size: 14px;
}

.bind-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  border: 1px dashed #d8d8d8;
  border-radius: 8px;
  color: #7d3c68;
  font-size: 15px;
  cursor: pointer;
}

.bind-plus {
  font-size: 36px;
  color: #c22988;
  margin-bottom: 8px;
}

.network-row {
  margin-bottom: 14px;
}

.network-row::v-deep .van-radio {
  align-items: flex-start;
}

.network-row::v-deep .van-radio__label {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
}

.network-name {
  font-weight: 500;
  margin-right: 4px;
}

.network-addr {
  color: #666;
  word-break: break-all;
}

.bank-summary {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

.bank-line span {
  color: #7d3c68;
}

.amount-row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebedf0;
  padding-bottom: 10px;
}

.amount-prefix {
  color: #c22988;
  font-size: 18px;
  font-weight: 600;
  margin-right: 8px;
}

.amount-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 15px;
  color: #333;
  min-width: 0;
}

.amount-input::placeholder {
  color: #c8c9cc;
}

.amount-all {
  color: #7d3c68;
  font-size: 14px;
  font-weight: 500;
  padding-left: 8px;
  cursor: pointer;
}

.remain-row {
  margin-top: 12px;
  font-size: 14px;
  color: #7d3c68;
}

.remain-value {
  color: #c22988;
  font-weight: 600;
}

.submit-btn {
  margin-top: 28px;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #e996ac;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.pwd-native-input {
  display: block;
  width: calc(100% - 32px);
  margin: 12px 16px 16px;
  height: 44px;
  padding: 0 12px;
  font-size: 18px;
  letter-spacing: 4px;
  text-align: center;
  border: 1px solid #ebedf0;
  border-radius: 8px;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
}
</style>
